module.exports = __webpack_public_path__ + "img/happiness-g68cf87109_1920.c39fef4c.jpeg";